export default process.env.API_ENDPOINT || 'https://api.student.surgu.ru/'
